export default class DomainPortail {
    constructor(data = {}) {
        this.id = data.id || null;
        this.code = data.code;
        this.libelle = data.libelle;
    }
}
